export default __webpack_public_path__ + "static/5-08ed3c33e2a69e0300bcd0fe3446a8c9.jpeg";